import auth from 'asc-jwt-auth-js';
import Router from '@/router';
import Store from '@/store';

export default {
	async init () {
		try {
			await auth.init({
				// REQUIRED
				localStorageKey: 'asc-coaching-reports',
				authenticationURL: `${process.env.API_URL}users/authenticate`,

				// OPTIONAL
				refreshURL: `${process.env.API_URL}users/reauthenticate`,
				setRefreshCredentials (token) {
					return {
						jwt: token
					};
				},
				getTokenFromResponse (response) {
					return response.data.something.something.jwt;
				},
				setAxiosHeaders (token) {
					axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
				},
				cleanAxiosHeaders () {
					axios.defaults.headers.common['Authorization'] = null;
				}
			});
			await this.refreshToken();
		} catch (error) {
			throw error;
		}
	},

	async authenticate (username, password) {
		try {
			let decodedToken = await auth.authenticate({
				username,
				password
			});
			console.log('Authenticated!');
			await Store.dispatch('getCurrentUser', decodedToken.uuid);
		} catch (error) {
			throw error;
		}
	},

	async refreshToken () {
		try {
			let decodedToken = await auth.refreshToken();
			console.log('Authenticated!');
			await Store.dispatch('getCurrentUser', decodedToken.uuid);
		} catch (error) {
			throw error;
		}
	},

	getJWT () {
		return auth.getJWT();
	},

	getJWTRaw () {
		return auth.getJWT(false);
	},

	async logout () {
		await auth.logout();
		Store.dispatch('removeCurrentUser');
		Router.push('/login');
	}

};



// WEBPACK FOOTER //
// ./src/mediator/auth.js